import { clearRouteConfig as clearRouteConfigAction } from '~/ocab-services/services.actions';
import { errorTypes, containsMessage } from '~/components';
import { routerSelectors } from '~/selectors';

const containsErrors = (errorMessages) =>
  containsMessage(errorMessages, errorTypes.NO_AVAILABLE_PARTNERS_GROUPS_ERROR);

export const clearRouteConfig = (store) => (next) => (action) => {
  next(action);

  if (action.type === '@@router/LOCATION_CHANGE') {
    const {
      editAppointment: { editMode },
      messages: {
        app: { errorMessages },
      },
    } = store.getState();
    const routerState = routerSelectors.selectLocationErrorState(store.getState());

    if (!editMode && !containsErrors(errorMessages) && !routerState.isError) {
      next(clearRouteConfigAction());
    }
  }
};
